function initPage6(vm) {
	vm.indexQuestionMainLA = 0;
	vm.indexQuestionSubLA = 0;

	vm.ngayDuSinh16 = false;
	vm.ngayDuSinh06 = false;
	
	vm.proposal.laList[2].questionnaireList[0].questionSeq = 3;
	vm.proposal.laList[2].questionnaireList[0].subQuestionSeq = 1;
	vm.proposal.laList[2].questionnaireList[1].questionSeq = 4;
	vm.proposal.laList[2].questionnaireList[1].subQuestionSeq = 1;
	vm.proposal.laList[2].questionnaireList[2].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[2].subQuestionSeq = 1;
	vm.proposal.laList[2].questionnaireList[3].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[3].subQuestionSeq = 2;
	vm.proposal.laList[2].questionnaireList[4].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[4].subQuestionSeq = 3;
	vm.proposal.laList[2].questionnaireList[5].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[5].subQuestionSeq = 4;
	vm.proposal.laList[2].questionnaireList[6].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[6].subQuestionSeq = 5;
	vm.proposal.laList[2].questionnaireList[7].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[7].subQuestionSeq = 6;
	vm.proposal.laList[2].questionnaireList[8].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[8].subQuestionSeq = 7;
	vm.proposal.laList[2].questionnaireList[9].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[9].subQuestionSeq = 8;
	vm.proposal.laList[2].questionnaireList[10].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[10].subQuestionSeq = 9;
	vm.proposal.laList[2].questionnaireList[11].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[11].subQuestionSeq = 10;
	vm.proposal.laList[2].questionnaireList[12].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[12].subQuestionSeq =11;
	vm.proposal.laList[2].questionnaireList[13].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[13].subQuestionSeq =12;
	vm.proposal.laList[2].questionnaireList[14].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[14].subQuestionSeq =13;
	vm.proposal.laList[2].questionnaireList[15].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[15].subQuestionSeq =14;
	vm.proposal.laList[2].questionnaireList[16].questionSeq = 5;
	vm.proposal.laList[2].questionnaireList[16].subQuestionSeq =15;
	vm.proposal.laList[2].questionnaireList[17].questionSeq = 6;
	vm.proposal.laList[2].questionnaireList[17].subQuestionSeq =1;
	vm.proposal.laList[2].questionnaireList[18].questionSeq = 7;
	vm.proposal.laList[2].questionnaireList[18].subQuestionSeq =1;
	vm.proposal.laList[2].questionnaireList[19].questionSeq = 8;
	vm.proposal.laList[2].questionnaireList[19].subQuestionSeq = 1;
	vm.proposal.laList[2].questionnaireList[20].questionSeq = 9;
	vm.proposal.laList[2].questionnaireList[20].subQuestionSeq =1;
	vm.proposal.laList[2].questionnaireList[21].questionSeq = 9;
	vm.proposal.laList[2].questionnaireList[21].subQuestionSeq =2;
	vm.proposal.laList[2].questionnaireList[22].questionSeq = 10;
	vm.proposal.laList[2].questionnaireList[22].subQuestionSeq = 1;
	vm.proposal.laList[2].questionnaireList[23].questionSeq = 11;
	vm.proposal.laList[2].questionnaireList[23].subQuestionSeq = 1;
	vm.proposal.laList[2].questionnaireList[24].questionSeq = 12;
	vm.proposal.laList[2].questionnaireList[24].subQuestionSeq = 1;
	vm.proposal.laList[2].questionnaireList[25].questionSeq = 13;
	vm.proposal.laList[2].questionnaireList[25].subQuestionSeq = 1;
	vm.proposal.laList[2].questionnaireList[26].questionSeq = 13;
	vm.proposal.laList[2].questionnaireList[26].subQuestionSeq = 2;
	vm.proposal.laList[2].questionnaireList[27].questionSeq = 14;
	vm.proposal.laList[2].questionnaireList[27].subQuestionSeq = 1;
	vm.proposal.laList[2].questionnaireList[28].questionSeq = 14;
	vm.proposal.laList[2].questionnaireList[28].subQuestionSeq = 2;
	vm.proposal.laList[2].questionnaireList[29].questionSeq = 14;
	vm.proposal.laList[2].questionnaireList[29].subQuestionSeq = 3;
	vm.proposal.laList[2].questionnaireList[30].questionSeq = 14;
	vm.proposal.laList[2].questionnaireList[30].subQuestionSeq = 4;
	vm.proposal.laList[2].questionnaireList[31].questionSeq = 14;
	vm.proposal.laList[2].questionnaireList[31].subQuestionSeq = 5;
	vm.proposal.laList[2].questionnaireList[32].questionSeq = 15;
	vm.proposal.laList[2].questionnaireList[32].subQuestionSeq = 1;
	vm.proposal.laList[2].questionnaireList[33].questionSeq = 15;
	vm.proposal.laList[2].questionnaireList[33].subQuestionSeq =2;
	vm.proposal.laList[2].questionnaireList[34].questionSeq = 15;
	vm.proposal.laList[2].questionnaireList[34].subQuestionSeq = 3;
	vm.proposal.laList[2].questionnaireList[35].questionSeq = 11;
	vm.proposal.laList[2].questionnaireList[35].subQuestionSeq = 2;
	vm.proposal.laList[2].questionnaireList[36].questionSeq = 16;
	vm.proposal.laList[2].questionnaireList[36].subQuestionSeq = 1;
	vm.proposal.laList[2].questionnaireList[37].questionSeq = 17;
	vm.proposal.laList[2].questionnaireList[37].subQuestionSeq = 1;
	
	vm.proposal.laList[3].questionnaireList[0].questionSeq = 3;
	vm.proposal.laList[3].questionnaireList[0].subQuestionSeq = 1;
	vm.proposal.laList[3].questionnaireList[1].questionSeq = 4;
	vm.proposal.laList[3].questionnaireList[1].subQuestionSeq = 1;
	vm.proposal.laList[3].questionnaireList[2].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[2].subQuestionSeq = 1;
	vm.proposal.laList[3].questionnaireList[3].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[3].subQuestionSeq = 2;
	vm.proposal.laList[3].questionnaireList[4].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[4].subQuestionSeq = 3;
	vm.proposal.laList[3].questionnaireList[5].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[5].subQuestionSeq = 4;
	vm.proposal.laList[3].questionnaireList[6].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[6].subQuestionSeq = 5;
	vm.proposal.laList[3].questionnaireList[7].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[7].subQuestionSeq = 6;
	vm.proposal.laList[3].questionnaireList[8].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[8].subQuestionSeq = 7;
	vm.proposal.laList[3].questionnaireList[9].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[9].subQuestionSeq = 8;
	
	vm.proposal.laList[3].questionnaireList[10].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[10].subQuestionSeq = 9;
	vm.proposal.laList[3].questionnaireList[11].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[11].subQuestionSeq = 10;
	vm.proposal.laList[3].questionnaireList[12].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[12].subQuestionSeq =11;
	vm.proposal.laList[3].questionnaireList[13].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[13].subQuestionSeq =12;
	vm.proposal.laList[3].questionnaireList[14].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[14].subQuestionSeq =13;
	vm.proposal.laList[3].questionnaireList[15].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[15].subQuestionSeq =14;
	vm.proposal.laList[3].questionnaireList[16].questionSeq = 5;
	vm.proposal.laList[3].questionnaireList[16].subQuestionSeq =15;
	vm.proposal.laList[3].questionnaireList[17].questionSeq = 6;
	vm.proposal.laList[3].questionnaireList[17].subQuestionSeq =1;
	vm.proposal.laList[3].questionnaireList[18].questionSeq = 7;
	vm.proposal.laList[3].questionnaireList[18].subQuestionSeq =1;
	vm.proposal.laList[3].questionnaireList[19].questionSeq = 8;
	vm.proposal.laList[3].questionnaireList[19].subQuestionSeq = 1;
	vm.proposal.laList[3].questionnaireList[20].questionSeq = 9;
	vm.proposal.laList[3].questionnaireList[20].subQuestionSeq =1;
	vm.proposal.laList[3].questionnaireList[21].questionSeq = 9;
	vm.proposal.laList[3].questionnaireList[21].subQuestionSeq =2;
	vm.proposal.laList[3].questionnaireList[22].questionSeq = 10;
	vm.proposal.laList[3].questionnaireList[22].subQuestionSeq = 1;
	vm.proposal.laList[3].questionnaireList[23].questionSeq = 11;
	vm.proposal.laList[3].questionnaireList[23].subQuestionSeq = 1;
	vm.proposal.laList[3].questionnaireList[24].questionSeq = 12;
	vm.proposal.laList[3].questionnaireList[24].subQuestionSeq = 1;
	vm.proposal.laList[3].questionnaireList[25].questionSeq = 13;
	vm.proposal.laList[3].questionnaireList[25].subQuestionSeq = 1;
	vm.proposal.laList[3].questionnaireList[26].questionSeq = 13;
	vm.proposal.laList[3].questionnaireList[26].subQuestionSeq = 2;
	vm.proposal.laList[3].questionnaireList[27].questionSeq = 14;
	vm.proposal.laList[3].questionnaireList[27].subQuestionSeq = 1;
	vm.proposal.laList[3].questionnaireList[28].questionSeq = 14;
	vm.proposal.laList[3].questionnaireList[28].subQuestionSeq = 2;
	vm.proposal.laList[3].questionnaireList[29].questionSeq = 14;
	vm.proposal.laList[3].questionnaireList[29].subQuestionSeq = 3;
	vm.proposal.laList[3].questionnaireList[30].questionSeq = 14;
	vm.proposal.laList[3].questionnaireList[30].subQuestionSeq = 4;
	vm.proposal.laList[3].questionnaireList[31].questionSeq = 14;
	vm.proposal.laList[3].questionnaireList[31].subQuestionSeq = 5;
	vm.proposal.laList[3].questionnaireList[32].questionSeq = 15;
	vm.proposal.laList[3].questionnaireList[32].subQuestionSeq = 1;
	vm.proposal.laList[3].questionnaireList[33].questionSeq = 15;
	vm.proposal.laList[3].questionnaireList[33].subQuestionSeq =2;
	vm.proposal.laList[3].questionnaireList[34].questionSeq = 15;
	vm.proposal.laList[3].questionnaireList[34].subQuestionSeq = 3;
	vm.proposal.laList[3].questionnaireList[35].questionSeq = 11;
	vm.proposal.laList[3].questionnaireList[35].subQuestionSeq = 2;
	vm.proposal.laList[3].questionnaireList[36].questionSeq = 16;
	vm.proposal.laList[3].questionnaireList[36].subQuestionSeq = 1;
	vm.proposal.laList[3].questionnaireList[37].questionSeq = 17;
	vm.proposal.laList[3].questionnaireList[37].subQuestionSeq = 1;
}